export const ToastContent = {
  en: 'Ingredient Collected!',
  ar: '!المكونات التي تم جمعها',
};

export const ProductComingSoon = {
  en: {
    title: 'Product Coming Soon',
    description: 'Stay tuned and return later to discover these skincare treasures from L’Occitane!',
  },
  ar: {
    title: 'المنتج قريبا',
    description: 'ابق على اتصال وارجع لاحقًا لاكتشاف كنوز العناية بالبشرة هذه من L’Occitane!',
  },
};

export const ArabicIngredients = {
  Lavender: 'لافندر',
  Immortelle: 'إمورتيل',
  Almond: 'اللوز',
  Shea: 'زبدة الشيا',
};

export const PDPContent = {
  en: {
    try: 'TRY IT',
    on: 'On',
    here: 'Here',
    collection: 'Collection',
    addToCart: 'Add To Cart',
    quantity: 'ml',
    currency: 'AED',
  },
  ar: {
    try: 'جربه',
    on: 'هنا',
    here: '',
    collection: 'مجموعة',
    addToCart: 'أضف إلى الحقيبة',
    quantity: 'مل',
    currency: 'د.إ',
  },
};

export const AudioModal = {
  en: {
    text: 'Would you like to enable audio?',
    yes: 'Yes',
    no: 'No',
  },
  ar: {
    text: 'هل ترغب في تفعيل الصوت',
    yes: 'نعم',
    no: 'كلا',
  },
};

export const WelcomeModal = {
  en: {
    topOne: 'Embark on a special ',
    topTwo: 'Virtual Journey',
    topThree: 'with us. Bon Voyage!',
    welcome: 'Welcome to',
    button: 'ENTER',
  },
  ar: {
    topOne: 'انطلق في',
    topTwo: 'رحلة افتراضية',
    topThree: '!رحلة سعيدة',
    welcome: 'أهلاً بكم في عالم',
    button: 'الدخول',
  },
};

export const InstructionModal = {
  en: {
    one: 'Hold and drag to explore your surroundings',
    two: 'Tap on the floor to move',
    three: 'Click on the icons to discover more',
    four: 'Go to menu to switch between the worlds',
    five: 'Collect 4 ingredients  to become a L’Occitane expert!',
  },
  ar: {
    one: 'اضغط ثم اسحب لتكتشف محيطك',
    two: 'اضغط على الأرض لتتحرك',
    three: 'انقر على الرموز لاكتشاف المزيد',
    four: 'اذهب إلى القائمة لاختيار العالم الذي تريد التجول به',
    five: 'جمع 4 مكونات لتصبح خبيرة في L’Occitane!',
  },
};

export const OverlayMenu = {
  en: {
    lavender: 'Lavender ',
    immortelle: 'Immortelle',
    almond: 'Almond',
    shea: 'Shea Butter',
    toStart: 'Back to start',
    instructions: 'Instructions',
  },
  ar: {
    lavender: 'لافندر',
    immortelle: 'إمورتيل',
    almond: 'اللوز',
    shea: 'زبدة الشيا',
    toStart: 'العودة إلى البداية',
    instructions: 'التعليمات',
  },
};
export const CongratulationsModal = {
  en: {
    congrats: 'CONGRATULATIONS!',
    bottomOne: 'You collected all the special L’Occitane ingredients!',
    bottomTwo: 'You are now a L’Occitane brand expert.',
  },
  ar: {
    congrats: '!مبروك',
    bottomOne: 'الآن بعد أن جمعت كل مكونات لوكسيتان المميزة حديقتنا السرية',
    bottomTwo: '.مفتوحة لك لجمع مكافأتك',
  },
};

export const ImmortelleOne = {
  en: {
    title: 'The art of extraction.',
    right: {
      one: 'Distillation is the process used to obtain immortelle essential oil and floral water.',
      two: 'Steam is passed through the fresh flowers and stems for two hours.',
      three: 'When the steam is cooled, it condenses to yield these two precious extracts.',
      four: 'The distillation is carried out on the day of the harvest, either on site or by one of our partner distillers.',
      circle: {
        one: 'In all,',
        two: '6 distilleries',
        three: 'produce our',
        four: 'essential oil.',
      },
    },
    left: {
      circle: {
        one: '1 ton',
        two: 'of flowers',
        three: 'is needed to',
        four: 'obtain 2 kg of',
        five: 'essential oil.',
      },
    },
  },
  ar: {
    title: '.فن استخراج الزيوت',
    right: {
      one: '.يمثل التقطير العملية المتّبعة لإنتاج زيت الخلود العطري والمياه الزهرية',
      two: 'تشتمل العملية على تمرير البخار عبر الزهور والسيقان لمدة ساعتين',
      three: '.وعندما يبرد البخار، يتكثّف لينتج هذين المستخلصين الثمينين',
      four: '.يتم إجراء عملية التقطير في يوم الحصاد، إما في الموقع نفسه أو بواسطة أحد معامل التقطير الشريكة',
      circle: {
        one: '،في الإجمال',
        two: 'لدينا 6',
        three: 'معامل تقطير',
        four: 'تنتج الزيت',
      },
    },
    left: {
      circle: {
        one: 'نحتاج إلى طن واحد',
        two: 'من الزهور لإنتاج 2',
        three: 'من الزيت كيلوغرام',
        four: 'العطري',
        five: '',
      },
    },
  },
};

export const ImmortelleTwo = {
  en: {
    title: 'Immortal beauty',
    text: 'Immortelle, means immortal. The flower owes its name to its exceptional longevity - even after they are picked they still look fresh. They never fade.',
  },
  ar: {
    title: 'جمال خالد',
    text: '.تعني كلمة "إمورتيل" الخلود. وتعود تسمية هذه الزهرة لطول عمرها الاستثنائي، إذ لا تزال تبدو متفتّحة حتى بعد قطفها. أي أنها لا تذبل أبداً الزهرة التي لا تذبل أبداً',
  },
};

export const ImmortelleThree = {
  en: {
    textOne: 'Immortelle flowers used by L`Occitane grow wildly in the Balagne region, in Corsica Island.',
    textTwo: 'Did you know?',
    circle: {
      one: 'A jar of',
      two: 'Divine Cream has',
      three: '600',
      four: 'of these',
      five: 'flowers in it.',
    },
  },
  ar: {
    textOne: '.تنمو زهور الخلود المستخدمة في منتجات لوكسيتان بشكل كبير في منطقة بلانيا في جزيرة كورسيكا',
    textTwo: 'هل تعلم؟',
    circle: {
      one: 'تحتوي كل عبوة',
      two: 'من كريم ديفاين على',
      three: '600 من هذه',
      four: 'الزهور',
      five: '',
    },
  },
};

export const ImmortelleFour = {
  en: {
    textOne: 'I could not see myself farming any other way than organically,',
    textTwo: 'and L’OCCITANE insisted on a certified-organic cultivation program.',
    textThree: 'It was a case of meeting the right people at the right time.',
    textFour: '- PASCALE CHÉRUBIN,',
    textFive: 'Immortelle producer in Corsica',
  },
  ar: {
    textOne: '.لم أتخيل أنني أستطيع ممارسة الزراعة إلا بالطريقة العضوية',
    textTwo: '.وقد أصرّت لوكسيتان على اتّباع برنامج معتمد للزراعة العضوية',
    textThree: '.ويعود ذلك إلى مقابلة الأشخاص المناسبين في الوقت المناسب',
    textFour: 'باسكال شيروبين-',
    textFive: 'منتجة إمورتيل في كورسيكا',
  },
};

export const ImmortelleIngredientContent = {
  en: {
    topText: 'Secret Ingredient Collected!',
    left: {
      title: 'SECRET INGREDIENT',
      textOne: 'A natural treasure that lives an exceptionally long life.',
      textTwo:
        'A gentle 100% natural alternative to Retinol, it supports skin’s architecture and helps increase skin’s density, boosting collagen synthesis, resulting in skin renewal and a thicker epidermis.',
    },
    right: {
      one: {
        title: 'SOURCE',
        textOne: 'Corsica, France',
        textTwo: 'Trusted local Producers',
        textThree: '100% Organic and Traceable Essential oil',
      },
      two: {
        title: 'BENEFITS',
        textOne: 'Restores scarred or damaged skin',
        textTwo: 'Helps with treatment of acne scars, blemishes',
        textThree: 'Fights the signs of ageing, the development of fine lines and under-eye wrinkles.',
        textFour: 'Renews the skin through detoxification and collagen production.',
      },
    },
    bottomTitle: 'IMMORTELLE',
    bottomText: 'Helichrysum arenarium',
    shop: 'Shop the full collection',
  },
  ar: {
    topText: 'تم جمع المكون السري',
    left: {
      title: 'المكوّن السرّي',
      textOne: '.كنز طبيعي يعيش حياة طويلة بشكل استثنائي',
      textTwo: 'بديل 100% طبيعي للريتينول، يدعم بنية البشرة ويعزز تكوين الكولاجين، مما يؤدي إلى تجديد خلايا البشرة',
    },
    right: {
      one: {
        title: 'المصدر',
        textOne: 'كورسيكا، فرنسا',
        textTwo: 'منتجين محليين موثوق بهم',
        textThree: 'زيت 100% عضوي وطبيعي',
      },
      two: {
        title: 'الفوائد',
        textOne: 'يعالج شوائب البشرة',
        textTwo: 'يساعد في علاج ندوب حب الشباب، وآثار',
        textThree: 'يحارب علامات التقدم بالعمر',
        textFour: 'يجدد البشرة من خلال إزالة السموم وإنتاج الكولاجين',
      },
    },
    bottomTitle: 'إيمورتيل',
    bottomText: 'ذهب الشمس الرملي',
    shop: 'تسوّق المجموعة الكاملة',
  },
};

export const LavenderOne = {
  en: {
    left: {
      title: 'Many Lavender Flowers for few essential oil',
      text: 'Distillation is carried out just after harvesting. 1 ton of lavender flowers yields 8 kg of essential oil.',
    },
    middle: {
      title: 'A L’Occitane Heritage',
      text: "The first lavender harvest reserved for L'OCCITANE took place in 1977.",
    },
    right: {
      title: 'Lavender growing conditions',
      text: 'Fine lavender grows at an altitude of anything from 600 to 1,700 metres!',
    },
  },
  ar: {
    left: {
      title: 'العديد من أزهار اللافندر لكمية قليلة من الزيت العطري',
      text: 'يتم التقطير بعد الحصاد مباشرة. طن واحد من أزهار اللافندر تنتج 8 كجم من الزيت العطري',
    },
    middle: {
      title: 'تراث لوكسيتان',
      text: 'في عام 1977، جرى أول حصاد من اللافندر المخصص لـ لوكسيتان.',
    },
    right: {
      title: 'ظروف نمو اللافندر',
      text: 'ينمو اللافندر الناعم على ارتفاع يتراوح بين 600 و 1700 متر!',
    },
  },
};

export const LavenderTwo = {
  en: {
    left: {
      circle: {
        one: 'Lavender,',
        two: 'also known as',
        three: 'Blue Gold',
        four: 'is the fragrant soul',
        five: 'of Provence.',
      },
    },
    right: {
      title: 'A Provençal Tradition',
      textOne: 'Lavender arrived in Provence more than 2,000 years ago, with the Romans.',
      textTwo: 'They used it for its scent, as well as its purifying and relaxing properties.',
      textThree:
        'Perfectly adapted to the arid conditions of the region, it soon became a defining element of the landscape, pharmacopoeia and economy of Provence.',
    },
  },
  ar: {
    left: {
      circle: {
        one: 'اللافندر،',
        two: 'معروف أيضاً',
        three: '"الذهب الأزرق"',
        four: 'هو الروح العطرة ',
        five: 'لبروفانس',
      },
    },
    right: {
      title: 'تقليد بروفانسي',
      textOne: 'وصل لافندر إلى بروفانس منذ أكثر من 2000 عام، مع الرومان',
      textTwo: 'لقد استخدموه لرائحته، بالإضافة إلى خصائصه المنقية والمريحة',
      textThree:
        'تكيفت تماماً مع الظروف القاحلة في المنطقة، وسرعان ما أصبحت عنصراً مميزاً للمناظر الطبيعية والأدوية واقتصاد بروفانس',
    },
  },
};

export const LavenderThree = {
  en: {
    title: 'A Very Real Threat',
    textOne:
      'The purple flower now is at risk, from drought-like conditions and disease-carrying insects, and needs protection.',
    textTwo:
      'For that, L’OCCITANE adapt its production methods to today´s environmental issues, and since 2012, has been supporting French research institutes in their efforts to find ecological solutions to save lavender.',
    textThree: 'As well as contributing to the change as one of the founding members of the Lavender Endowment Fund.',
  },
  ar: {
    title: 'الخطر الحقيقي',
    textOne: '.الزهرة الأرجوانية الآن في خطر، من ظروف شبيهة بالجفاف والحشرات الحاملة للأمراض، وتحتاج إلى الحماية',
    textTwo:
      '.لذلك، تقوم لوكسيتان بتكييف طرق إنتاجها مع القضايا البيئية اليوم، ومنذ عام 2012، تدعم معاهد الأبحاث الفرنسية في جهودها لإيجاد حلول بيئية لإنقاذ اللافندر',
    textThree: '.بالإضافة إلى المساهمة في التغيير كأحد الأعضاء المؤسسين لصندوق هبات لافندر',
  },
};

export const LavenderFour = {
  en: {
    title: 'A Renowned Label',
    textOne:
      'Fine lavender from Haute-Provence - Lavandula angustifolia - is protected by a PDO (Protected Designation of Origin), which guarantees the quality and traceability of the essential oil.',
    textTwo:
      'To qualify for this label, lavender must grow at an altitude over 800m, within a specific geographic area; and be distilled using traditional methods.',
  },
  ar: {
    title: 'علامة مشهورة',
    textOne: 'اللافندر الراقي من بروفانس محمي من قبل الـ (PDO)، والذي يضمن جودة وتتبع للزيت الأساسي',
    textTwo:
      'لكي تكون مؤهلة للحصول على هذه العلامة، يجب أن ينمو اللافندر على ارتفاع يزيد عن 800 متر، داخل منطقة جغرافية محددة؛ ويتم تقطيرها باستخدام الطرق التقليدية',
  },
};

export const LavenderIngredientContent = {
  en: {
    topText: 'Secret Ingredient Collected!',
    left: {
      title: 'SECRET INGREDIENT',
      textOne:
        'Lavender has been part of the L’OCCITANE DNA for decades and was one of the first flowers used by our founder, Olivier Baussan. Its unique fragrance has become an aromatic tribute to Provence, earning the nickname “blue gold” from locals.',
    },
    right: {
      one: {
        title: 'SOURCE',
        textOne: 'Provence, The Bleu Provence, France',
        textTwo: 'Trusted local farms',
        textThree: 'Badge of quality:',
        textFour: 'PDO Label - Protected Designation of Origin',
      },
      two: {
        title: 'BENEFITS',
        textOne: 'Calming effect',
        textTwo: 'Promotes good night’s sleep',
        textThree: 'Helps with skin breakouts, hyperpigmentation',
        textFour: 'Soothes dry and irritated skin',
      },
    },
    bottomTitle: 'LAVENDER',
    bottomText: 'Lavandula angustifolia',
    shop: 'Shop the full collection',
  },
  ar: {
    topText: 'تم جمع المكون السري',
    left: {
      title: 'المكوّن السرّي',
      textOne:
        'لطالما شكّلت زهرة اللافندر أحد المكوّنات الأساسية لمنتجات لوكسيتان منذ عقود، كما كانت إحدى الزهور الأولى التي استخدمها مؤسّس العلامة التجارية، أوليفييه بوسان. وبفضل عطرها المميز، أصبحت بمثابة رمز عطري في بروفانس، بحيث أعطاها السكان المحليون لقب "الذهب الأزرق"',
    },
    right: {
      one: {
        title: 'المصدر',
        textOne: 'بروفانس. ذا بلو بروفانس، فرنسا',
        textTwo: 'مزارع محلية موثوقة',
        textThree: ':شارة الجودة',
        textFour: 'تسمية المنشأ المحميّة',
      },
      two: {
        title: 'الفوائد',
        textOne: 'تترك أثراً مهدئاً',
        textTwo: 'تعزّز النوم الجيد ليلاً',
        textThree: 'تساعد في علاج البثور وحالات فرط التصبغ',
        textFour: 'تهدّئ البشرة الجافة والمتهيجة',
      },
    },
    bottomTitle: 'لافندر',
    bottomText: 'لافاندولا أوغستيفوليا',
    shop: 'تسوّق المجموعة الكاملة',
  },
};

export const AlmondOne = {
  en: {
    title: 'A day in Provence',
    text: 'In the past, people lived according the rhythm of nature. In the evening, women would meet in the local community center, called the “Dégovarelle.” Here they would remove the almond hulls while the men emptied the shells. It was a really special moment, a time for enjoying one other’s company, while snacking on "oreillettes," traditional fried dough treats from Provence. It was a beautiful way to spend a night in the countryside, before television existed!',
    circle: {
      one: 'Valensole almonds',
      two: 'were picked by hand',
      three: 'and carried in,',
      four: 'bannetons,',
      five: 'large wicker baskets',
      six: 'from Provence.',
    },
  },
  ar: {
    title: 'يوم في بروفانس',
    text: 'في الماضي، كانت حياة الناس متناغمة مع إيقاع الطبيعة. فاعتادت النساء في المساء التجمّع في المركز المجتمعي المحلي، الذي يُدعى "ديغوفاريل"، حيث يعملن على إزالة قشر اللوز بينما يقوم الرجال بإفراغ القشور. لقد كانت تلك اللحظات مميزة، حيث كان الناس يقضون وقتاً ممتعاً برفقة الآخرين بينما يتناولون "الأورييت"، وهي حلويات تقليدية من بروفانس مصنوعة من العجين المقلي. كانت طريقة رائعة لقضاء ليلة في الريف قبل عصر التلفاز',
    circle: {
      one: 'يتم قطف اللوز في',
      two: 'فالينسول، ثم يُنقل بواسطة',
      three: 'سلال كبيرة مصنوعة من',
      four: 'الخوص في بروفانس تُدعى',
      five: '"بانتون"',
      six: '',
    },
  },
};

export const AlmondTwo = {
  en: {
    title: 'The return of Almonds in Provence',
    textOne: 'Until the beginning of the last century, the almond tree was a strong symbol of the Provençal landscape.',
    textTwo:
      'Abandoned for more profitable crops, it almost disappeared from the region. L`Occitane has chosen to source its almonds from producers in the South of France, to help revive this traditional industry.',
    circle: {
      one: 'In 2018, L’OCCITANE',
      two: 'helped create',
      three: 'France Amande,',
      four: 'a trade association aiming',
      five: 'to breathe new life into',
      six: 'French almond sector.',
    },
  },
  ar: {
    title: 'عودة أشجار اللوز إلى بروفانس',
    textOne: 'بقيت شجرة اللوز رمزاً للمناظر الطبيعية في بروفانس حتى بداية القرن الماضي',
    textTwo:
      'ولكن سرعان ما تم التخلّي عن زراعتها لصالح محاصيل تعود بربح أكبر، ما أدّى إلى اختفائها من المنطقة تقريباً. ولذلك، اختارت لوكسيتان التعاون مع منتجين في جنوب فرنسا للتزوّد باللوز الذي تستخدمه لصنع منتجاتها، من أجل المساهمة في إعادة إحياء هذه الزراعة التقليدية',
    circle: {
      one: 'في عام 2018',
      two: '،ساعدت لوكسيتان في',
      three: 'France Amande إنشاء',
      four: 'وهي جمعية تجارية',
      five: 'تهدف إلى إعادة',
      six: 'إحياء قطاع اللوز الفرنسي',
    },
  },
};

export const AlmondThree = {
  en: {
    title: 'Did you know?',
    textOne:
      'Almond flowers are a great source of nectar and pollen for the bees, which in return are crucial to pollinate the almond flowers.',
    textTwo: '300 beehives are hosted in the middle of our almond trees.',
    circleLeft: {
      one: ' 1 almond tree',
      two: '20 kg or almonds',
    },
    circleRight: {
      one: '2.5 kg of almonds',
      two: '1kg of essential oil',
    },
  },
  ar: {
    title: 'هل تعلم؟',
    textOne: 'تُعتبر زهرة اللوز مصدراً مهماً للرحيق وحبوب لقاح النحل، الذي يساهم بدوره في تلقيح أزهار اللوز',
    textTwo: 'ولذلك، وزّع أحد منتجينا، جان بيير جوبير، 300 خلية نحل بين أشجار اللوز في حديقته',
    circleLeft: {
      one: 'شجرة لوز واحدة',
      two: 'كيلوغراماً من اللوز 20',
    },
    circleRight: {
      one: '2.5 كيلوغرام من اللوز',
      two: '1 كيلوغرام من الزيت العطري',
    },
  },
};

export const AlmondFour = {
  en: {
    title: 'An ingredient in all form',
    textOne:
      'L`Occitane purchases all the whole almonds (and broken almonds that would be thrown away, with same properties as whole almonds) from its partners in the South of France.',
    textTwo:
      'The Group also makes good use of other products derived from the almond tree – the shells, buds, native cells and nuts – ensuring that as little as possible goes to waste!',
    almondNut: 'Sweet Almond Nut Shell',
    almondOil: 'Sweet Almond Oil',
    almondMilk: 'Sweet Almond Milk',
  },
  ar: {
    title: 'مكوّن يُستخدَم بجميع أشكاله',
    textOne:
      'تشتري مجموعة لوكسيتان حبوب اللوز الكاملة (وحبوب اللوز المكسورة التي عادةً ما يتم التخلّص منها، والتي تتمتّع بخصائص الحبوب الكاملة نفسها) من شركائها في جنوب فرنسا',
    textTwo:
      'كما تستفيد المجموعة من منتجات أخرى مشتقّة من شجرة اللوز، منها القشور، والبراعم، والبذور الأصلية، والحبوب، ما يضمن أقل قدر ممكن من الهدر!',
    almondNut: 'قشر اللوز الحلو',
    almondOil: 'زيت اللوز الحلو',
    almondMilk: 'حليب اللوز الحلو',
  },
};

export const AlmondIngredientContent = {
  en: {
    topText: 'Secret Ingredient Collected!',
    left: {
      title: 'SECRET INGREDIENT',
      textOne:
        "A true treasure of nature and rich in vitamins, it moisturises, nourishes and softens amongst it’s many benefits. At L'OCCITANE, we use Almond in all its textures, oil, butter, crushed cockles, protein and milk. This allows us to recover all the benefits and all the textures of this gourmet ingredient!",
    },
    right: {
      one: {
        title: 'SOURCE',
        textOne: 'South of France, Valensole Plateau',
        textTwo: 'Trusted local producers',
        textThree: 'Over 80 hectares of cultivation',
      },
      two: {
        title: 'BENEFITS',
        textOne: 'Nourishes, softens the skin with Omega 9 fatty acids',
        textTwo: 'Can even out skin tone',
        textThree: 'Helps protect the skin’s protective barrier with its richness in Squalene',
        textFour: 'Fights loss of elasticity',
        textFive: 'Reduces the appearance of stretch marks',
      },
    },
    bottomTitle: 'ALMOND',
    bottomText: 'Prunus Amygdalus',
    shop: 'Shop the full collection',
  },
  ar: {
    topText: 'تم جمع المكون السري',
    left: {
      title: 'المكوّن السرّي',
      textOne:
        'كنز حقيقي من الطبيعة وغني بالفيتامينات، فهو يرطب ويغذى وينعم البشرة. في لوكسيتان، نستخدم اللوز بكل نسيجاته، الزيت، الزبدة، المكسرات، البروتين والحليب. هذا يسمح لنا باستعادة جميع الفوائد وكل نسيج هذا المكون الرائع',
    },
    right: {
      one: {
        title: 'المصدر',
        textOne: 'جنوب فرنسا، هضبة فالنسول',
        textTwo: 'منتجين محليين موثوق بهم',
        textThree: 'زراعة أكثر من 80 هكتارا',
      },
      two: {
        title: 'الفوائد',
        textOne: 'يغذي ويلين البشرة بأحماض أوميغا 9 الدهنية',
        textTwo: ' يوحد لون البشرة',
        textThree: ' يساعد في حماية الحاجز الواقي للبشرة لأنه غني بالسكوالين',
        textFour: ' يحارب فقدان المرونة',
        textFive: 'يقلل من ظهور علامات التمدد',
      },
    },
    bottomTitle: 'اللوز',
    bottomText: 'برقوق أميجدالوس',
    shop: 'تسوّق المجموعة الكاملة',
  },
};

export const SheaOne = {
  en: {
    title: 'It starts with a nut',
    text: 'The Shea nut is famous for the fatty kernel it contains, which has intensely nourishing and protective properties. These give it amazing beauty benefits and help prevent skin from drying. Shea Butter is good for all skin types, hair types, and can even be used on babies!',
  },
  ar: {
    title: 'بدأت القصة من جوزة',
    text: 'تشتهر جوزة الشيا بالنواة الدهنية التي تحتوي عليها، والتي تتمتع بخصائص مغذية ووقائية مكثفة، تمنح جمال مذهل وتساعد في منع البشرة من الجفاف. زبدة الشيا مفيدة لجميع أنواع البشرة وأنواع الشعر ويمكن استخدامها حتى على الأطفال',
  },
};

export const SheaTwo = {
  en: {
    title: 'Guardians of the ecosystem',
    textOne: 'Did you know that only women can pick Shea nuts and turn shea kernels into shea butter?',
    textTwo: 'It is a tradition passed down through generations, mother to daughter.',
    textThree:
      "For the Women's Co-operatives in Ghana & Burkina Faso, when it comes to the Shea trees, their every act is an act of care.",
    textFour:
      "They collect only the ripest shea fruit & only from the ground, as to not harm the tree. To make certain of this, they'll even walk much further afield if needed.",
    circle: {
      one: 'Shea butter is',
      two: 'called "women’s',
      three: 'gold" in Burkina',
      four: 'Faso.',
    },
  },
  ar: {
    title: 'حُرّاس النظام البيئي',
    textOne: 'هل تعلم أن النساء فقط يمكنهن قطف الجوز وتحويله إلى زبدة شيا؟',
    textTwo: '.إنه تقليد ينتقل عبر الأجيال',
    textThree:
      '.أما بالنسبة للتعاونيات النسائية في غانا وبوركينا فاسو، عندما يتعلق الأمر بأشجار الشيا، فإن كل عمل لهم هو عمل مهني',
    textFour: '.إنهم يجمعون فقط فاكهة الشيا الأكثر نضجاً وفقط من الأرض، حتى لا يؤذوا الشجرة',
    circle: {
      one: 'زبدة الشيا تسمى',
      two: 'ذهب"',
      three: '"المرأة',
      four: 'في بوركينا فاسو',
    },
  },
};

export const SheaThree = {
  en: {
    title: 'Making difference to women’s lives',
    textOne: "Since 1980s, we've built up a joint development partnership with the women producers of Burkina Faso.",
    textTwo: "They are the pillars of society and play a key role in the country's economic and social development.",
    textThree:
      "Our goal is to help them become more financially autonomous. By earning their own income and developing their activities, they are able to improve their social status, contribute more to household expenses and help to pay for their children's education. The whole family benefits!",
    circle: {
      one: 'There were about 12',
      two: 'women supported by',
      three: 'L’Occitane in 1980s.',
      four: 'To date, there are over',
      five: '42,600!',
    },
  },
  ar: {
    title: 'إحداث فرق في حياة المرأة',
    textOne: 'منذ الثمانينيات، أقمنا شراكة تنمية مشتركة مع المُنتِجات في بوركينا فاسو',
    textTwo: 'هن من ركائز المجتمع يلعبن دوراً رئيسياً في التنمية الاقتصادية والاجتماعية للبلد',
    textThree:
      'هدفنا هو مساعدتهن على أن يصبحن أكثر استقلالية من الناحية المالية. ومن خلال كسب دخلهن وتطوير أنشطتهن، يمكنهن تحسين وضعهن الاجتماعي، والمساهمة بشكل أكبر في نفقات الأسرة المعيشية والمساعدة في دفع تكاليف تعليم أطفالهم. هي منفعة للعائلة بكاملها!',
    circle: {
      one: 'كان هناك حوالي 12 امرأة',
      two: 'تدعمهن لوكسيتان في',
      three: 'عام 1980',
      four: 'حتى الآن، هناك أكثر من ',
      five: '42,000!',
    },
  },
};

export const SheaFour = {
  en: {
    title: 'Women and Shea in figures',
    right: {
      one: 'women have benefited from RESIST programme',
      oneDigit: '10,000',
      two: 'women have been able to open their shea businesses to other clients to increase their income',
      twoDigit: '5400',
      three: 'have benefited from help to mechanise production processes',
      threeDigit: '6000',
    },
    left: {
      circleOne: {
        textOne: 'women have',
        textTwo: 'been able to diversify',
        textThree: 'their income by',
        textFour: 'producing hibiscus',
        digit: '1000',
      },
      circleTwo: {
        textOne: 'women have',
        textTwo: 'been made aware of',
        textThree: 'the importance of',
        textFour: 'protecting trees',
        digit: '8500',
      },
    },
  },
  ar: {
    title: 'النساء والشيا في الأرقام',
    right: {
      one: 'RESIST استفادت امرأة من برنامج',
      oneDigit: '10,000',
      two: 'تمكنت امرأة من فتح أعمالهن التجارية لزبائن آخرين لزيادة دخلهن',
      twoDigit: '5400',
      three: 'استفادت امرأة من المساعدة لزيادة عمليات الإنتاج',
      threeDigit: '6000',
    },
    left: {
      circleOne: {
        textOne: 'تمكنت امرأة ',
        textTwo: 'من تنويع دخلهن',
        textThree: 'عن طريق إنتاج',
        textFour: 'الكركديه',
        digit: '1000',
      },
      circleTwo: {
        textOne: 'تم توعية',
        textTwo: 'امرأة على',
        textThree: 'أهمية حماية',
        textFour: 'الأشجار',
        digit: '8500',
      },
    },
  },
};

export const SheaFive = {
  en: {
    title: 'Four areas of action',
    rightText:
      'In Burkina Faso, our Foundation works on ways to open up opportunities for women and offer them a brighter future. By focusing on these 4 key areas.',
    rightCircleOne: {
      one: 'Providing women and their',
      two: 'children access to',
      three: 'education',
    },
    rightCircleTwo: {
      one: 'Breaking the cycle of',
      two: 'illiteracy',
    },
    leftCircleOne: {
      one: 'Giving women',
      two: 'entrepreneurs',
      three: 'a much-needed',
      four: 'financial boost with',
      five: 'microcredits',
    },
    leftCircleTwo: {
      one: 'entrepreneurship',
      two: "L'OCCITANE Foundation has",
      three: 'joined forces with the NGO',
      four: '"Entrepreneurs du Monde" to',
      five: 'help women develop',
      six: 'economic initiatives and',
      seven: 'generate additional incomes.',
    },
  },
  ar: {
    title: 'مجالات العمل الأربعة',
    rightText:
      'في بوركينا فاسو، تعمل مؤسستنا على إيجاد طرق لفتح الفرص أمام النساء وتقديم مستقبل أكثر إشراقاً لهن. بالتركيز على هذه المجالات الأربعة الرئيسية:',
    rightCircleOne: {
      one: 'إتاحة فرص',
      two: 'التعليم للنسا',
      three: 'وأطفالهن',
    },
    rightCircleTwo: {
      one: 'نعمل على',
      two: 'محو الأمية',
    },
    leftCircleOne: {
      one: 'منح',
      two: 'رائدات الأعمال',
      three: 'دفعة مالية',
      four: 'لدعم عملها',
    },
    leftCircleTwo: {
      one: 'تنظيم المشاريع',
      two: 'انضمت مؤسسة لوكسيتان',
      three: 'إلى المنظمة غير الحكومية',
      four: 'نظمو المشاريع في',
      five: 'العالم لمساعدة النسا',
      six: 'على تطوير المبادرات ',
      seven: 'الاقتصادية وتوليد دخل إضافي',
    },
  },
};

export const SheaIngredientContent = {
  en: {
    topText: 'Secret Ingredient Collected!',
    left: {
      title: 'SECRET INGREDIENT',
      textOne:
        'Derived from the kernels of the wild Shea fruit trees, shea butter is, in its most natural state, a fatty substance which can change and alter its state according to the temperature it is kept at. Shea butter can be applied directly as a moisturiser both to skin and to hair.',
    },
    right: {
      one: {
        title: 'SOURCE',
        textOne: 'Burkina Faso, Ghana',
        textTwo: '100% Fair Trade',
        textThree: 'Purchased directly from Women Producers',
      },
      two: {
        title: 'BENEFITS',
        textOne: 'Soothes and hydrates dry to very dry shin,',
        textTwo: 'Helps with eczema, sunburn, burns, skin irritation',
        textThree: 'Protects the skin with a barrier that seals in moisture.',
        textFour: 'Nourishes, and softens',
      },
    },
    bottomTitle: 'SHEA NUTS',
    bottomText: 'Vitellaria paradoxa',
    shop: 'Shop the full collection',
  },
  ar: {
    topText: 'تم جمع المكون السري',
    left: {
      title: 'المكوّن السرّي',
      textOne:
        'مشتقة من أشجار فاكهة الشيا البرية، زبدة الشيا، في أكثر حالاتها طبيعية، مادة دهنية يمكن أن تتغير وتغير حالتها وفقاً لدرجة الحرارة التي يتم الاحتفاظ بها فيها. يمكن وضع زبدة الشيا مباشرة كمرطب على البشرة والشعر.',
    },
    right: {
      one: {
        title: 'المصدر',
        textOne: 'بوركينا فاسو، غانا',
        textTwo: 'تجارة عادلة بنسبة % 100',
        textThree: 'تم شراؤها مباشرة من المُنتِجات',
      },
      two: {
        title: 'الفوائد',
        textOne: 'تهدئة وترطيب البشرة الجافة إلى الجافة جداً',
        textTwo: 'تساعد في حالات الأكزيما والحروق وتحسس البشرة',
        textThree: 'يحمي البشرة بحاجز وقائي',
        textFour: 'يغذي وينعم',
      },
    },
    bottomTitle: 'الشيا',
    bottomText: 'فيتيلاريا بارادوكس',
    shop: 'تسوّق المجموعة الكاملة',
  },
};
